import { render, staticRenderFns } from "./TabelaItemKit.vue?vue&type=template&id=6b756d14"
import script from "./TabelaItemKit.vue?vue&type=script&lang=ts"
export * from "./TabelaItemKit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports